import { z } from 'zod';

export const TopicName = z.enum(['Общая', 'Конкуренты', 'Макро', 'Опер деятельность']);

const TopicNameOptions = TopicName.options;
const TopicNameSet = new Set<string>(TopicNameOptions);

export const TopicNameWithFallback = z.string().transform((value) => {
  const parsed = TopicName.safeParse(value);

  return parsed.success ? parsed.data : value;
});

export const { enum: TopicNameEnum } = TopicName;

export type TopicNameKey = z.infer<typeof TopicName>;
export type TopicNameValue = z.infer<typeof TopicNameWithFallback>;

export const isTopicNameKey = (value: string): value is TopicNameKey => TopicNameSet.has(value);

export const TopicSchema = z
  .object({
    id: z.number().int(),
    organization_id: z.number().int(),
    name: TopicNameWithFallback,
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
  })
  .transform((raw) => ({
    id: raw.id,
    organizationId: raw.organization_id,
    name: raw.name,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export type TopicEntityApi = z.input<typeof TopicSchema>;
export type TopicEntity = z.infer<typeof TopicSchema>;

export const TopicEntityListSchema = z.array(TopicSchema);
